import { render, staticRenderFns } from "./ubtzyouth.vue?vue&type=template&id=1e9d3c38&"
import script from "./ubtzyouth.vue?vue&type=script&lang=js&"
export * from "./ubtzyouth.vue?vue&type=script&lang=js&"
import style0 from "./ubtzyouth.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports